export const LOGIN_REQUEST = 'auth/USERS_LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'auth/USERS_LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'auth/USERS_LOGIN_FAILURE';
export const LOGOUT = 'auth/USERS_LOGOUT';

export const SET_CLIENT = 'auth/SET_CLIENT';
export const SET_RETURNING_USER = 'auth/SET_RETURNING_USER';
export const SET_USERNAME_AND_APP_URL = 'auth/SET_USERNAME_AND_APP_URL';
export const NEW_PASSWORD_REQUEST = 'auth/USERS_NEW_PASSWORD_REQUEST';

export const RESET_PASSWORD_REQUEST = 'auth/USERS_RESET_PASSWORD_REQUEST';
export const SET_PASSWORD_RESET_STATUS = 'auth/SET_PASSWORD_RESET_STATUS';
export const FORGOT_PASSWORD_CONFIRM = 'auth/FORGOT_PASSWORD_CONFIRM';

export const SESSION_REQUEST = 'auth/USERS_SESSION_REQUEST';
export const SESSION_SUCCESS = 'auth/USERS_SESSION_SUCCESS';
export const SESSION_FAILURE = 'auth/USERS_SESSION_FAILURE';

const initialState = {};

export default function authentication(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case LOGIN_REQUEST:
      return {
        ...state,
        username: payload.username,
        password: payload.password
      };
    case RESET_PASSWORD_REQUEST:
      return {
        ...state,
        username: payload.username
      };
    case SET_PASSWORD_RESET_STATUS:
      return {
        ...state,
        passwordReset: payload.passwordReset
      };
    case SET_CLIENT:
      return {
        ...state,
        client: payload.client
      };
    case SET_RETURNING_USER:
      return {
        ...state,
        returningUser: {
          email: payload.email,
          firstName: payload.firstName
        }
      };
    case SET_USERNAME_AND_APP_URL:
      return {
        ...state,
        ...payload
      };
    case LOGIN_FAILURE:
      return initialState;
    case LOGOUT:
      return {};
    default:
      return state;
  }
}

export const loginRequestAction = ({
  username,
  password,
  new_password = '',
  onFailure = () => null
}) => ({
  type: LOGIN_REQUEST,
  payload: {
    username,
    password,
    new_password,
    onFailure
  }
});

export const newPasswordRequest = ({ new_password, onFailure = () => null }) => ({
  type: NEW_PASSWORD_REQUEST,
  payload: {
    new_password,
    onFailure
  }
});

export const setReturningUser = ({ email, firstName }) => ({
  type: SET_RETURNING_USER,
  payload: {
    email,
    firstName
  }
});

export const setLoggedUser = ({ username, client_name, app_url }) => ({
  type: SET_USERNAME_AND_APP_URL,
  payload: {
    username,
    client_name,
    app_url
  }
});
export const setClient = client => ({
  type: SET_CLIENT,
  payload: {
    client
  }
});

export const resetPasswordRequest = ({ username, onFailure = () => null }) => ({
  type: RESET_PASSWORD_REQUEST,
  payload: { email: username, onFailure }
});

export const setPasswordResetStatus = ({ passwordReset }) => ({
  type: SET_PASSWORD_RESET_STATUS,
  payload: { passwordReset }
});

export const forgotPasswordConfirm = ({ email, password, onFailure = () => null }) => ({
  type: FORGOT_PASSWORD_CONFIRM,
  payload: { email, password, onFailure }
});

export const checkUserSession = () => ({
  type: SESSION_REQUEST
});



// WEBPACK FOOTER //
// ./src/core/auth/index.js